module.exports = __webpack_public_path__ + "static/media/ExcelIcon.3cb486b3.svg";